import { render } from "./Report.vue?vue&type=template&id=d36d8916&scoped=true&ts=true"
import script from "./Report.vue?vue&type=script&lang=ts"
export * from "./Report.vue?vue&type=script&lang=ts"

import "./Report.vue?vue&type=style&index=0&id=d36d8916&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d36d8916"]])

export default __exports__